import { captureStack1fzi4aczwc4hg as captureStack } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlinx_io_IOException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_2);
}
var IOExceptionClass;
function IOException() {
  if (IOExceptionClass === VOID) {
    class $ extends Exception() {
      static new_kotlinx_io_IOException_28biy1_k$() {
        var $this = this.new_kotlin_Exception_f32mds_k$();
        init_kotlinx_io_IOException($this);
        return $this;
      }
      static new_kotlinx_io_IOException_wvwdyo_k$(message) {
        var $this = this.new_kotlin_Exception_hsqbop_k$(message);
        init_kotlinx_io_IOException($this);
        return $this;
      }
      static new_kotlinx_io_IOException_pmronu_k$(message, cause) {
        var $this = this.new_kotlin_Exception_9qyiel_k$(message, cause);
        init_kotlinx_io_IOException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'IOException', $.new_kotlinx_io_IOException_28biy1_k$);
    IOExceptionClass = $;
  }
  return IOExceptionClass;
}
function init_kotlinx_io_EOFException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_3);
}
var EOFExceptionClass;
function EOFException() {
  if (EOFExceptionClass === VOID) {
    class $ extends IOException() {
      static new_kotlinx_io_EOFException_pc0t1h_k$() {
        var $this = this.new_kotlinx_io_IOException_28biy1_k$();
        init_kotlinx_io_EOFException($this);
        return $this;
      }
      static new_kotlinx_io_EOFException_1f8u0y_k$(message) {
        var $this = this.new_kotlinx_io_IOException_wvwdyo_k$(message);
        init_kotlinx_io_EOFException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'EOFException', $.new_kotlinx_io_EOFException_pc0t1h_k$);
    EOFExceptionClass = $;
  }
  return EOFExceptionClass;
}
//region block: exports
export {
  EOFException as EOFExceptionh831u25jcq9n,
  IOException as IOException1wyutdmfe71nu,
};
//endregion

//# sourceMappingURL=-PlatformJs.mjs.map
